import React, {useEffect, useState} from 'react';
import './appNews.scss';
import {useNavigate, useParams} from "react-router-dom";
import {NewsDataTypes} from "../../../models";
import {Button} from "../../../components";
import {useGetArticles} from 'operations/queries';
import {escapeHtml} from 'util/removeHtmlFromString';
import ReactMarkdown from "react-markdown";

const AppNews = () => {
    let {newsId} = useParams();
    const [news, setNews] = useState<NewsDataTypes>();
    const navigate = useNavigate();
    const {data: articleData} = useGetArticles();
    const [articles, setArticles] = useState<Array<NewsDataTypes>>([])

    useEffect(() => {
        if (!articleData) return
        let articleList: Array<NewsDataTypes> = [];

        articleData.forEach((article: any) => {
            const articleInfo = article.attributes

            articleList.push({
                id: article.id,
                date: articleInfo.date?.split("T")[0],
                image: process.env.REACT_APP_BASE_URL + articleInfo.image.data.attributes.url,
                author: articleInfo.author,
                heading: articleInfo.heading,
                description: articleInfo.description,
                body: articleInfo.body,
                link: articleInfo?.link ?? "N/A",
                isPopular: articleInfo?.isPopular ?? 'N/A',
                headerImage: process.env.REACT_APP_BASE_URL + articleInfo.headerImage.data.attributes.url
            })
        })
        setArticles(articleList)
    }, [articleData]);

    useEffect(() => {
        setNews(articles.filter((data: any) => (data.id === parseInt(newsId as string)))[0]);
    }, [newsId, articles])


    return (
        <div className={'app-news'} id={'app-news'}>
            <div className={'app-news_wrapper max'}>
                <img src={news?.headerImage} alt=""/>
                <h1 id={'heading'}>{news?.heading}</h1>
                <span id="date">{news?.date}</span>
                <span id="author">By: {news?.author} courtesy of SBAJ</span>
                <div className="app-news_wrapper_sections">
                    <ReactMarkdown>
                        {news?.body}
                    </ReactMarkdown>
                </div>


                <div className={'app-news_wrapper_cta'}>
                    <Button text={'View More Articles'} type={'primary'} onclick={() => navigate('/app/news')}/>
                    <Button text={'Back'} type={'secondary'} onclick={() => navigate(-1)}/>
                </div>
            </div>
        </div>
    );
};

export default AppNews;
